import { isObject } from "./isObject";

export function mergeObjects<T1 extends Record<string, unknown>>(target: T1, source: Record<string, unknown>): T1 {
  if (!isObject(target) || !isObject(source)) {
    return source as T1;
  }

  const targetShallowCopy: Record<string, unknown> = { ...target };

  for (const key in source) {
    if (!Object.prototype.hasOwnProperty.call(source, key)) {
      continue;
    }

    const targetValue = target[key];
    const sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      targetShallowCopy[key] = [...sourceValue];
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      targetShallowCopy[key] = mergeObjects(targetValue, sourceValue);
    } else if (Array.isArray(sourceValue)) {
      targetShallowCopy[key] = [...sourceValue];
    } else if (isObject(sourceValue)) {
      targetShallowCopy[key] = { ...sourceValue };
    } else {
      targetShallowCopy[key] = sourceValue;
    }
  }

  return targetShallowCopy as T1;
}
